// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__5Uhmf","disabled":"FileBtn_disabled__2nzvZ","warn":"FileBtn_warn__3f2nm","fade":"FileBtn_fade__2eRLR"};